module.exports = __webpack_public_path__ + "assets/Angle54Detailed.f88f57dbef65398c2bb4404f26ca48b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Angle54Detailed.png
// module id = 462
// module chunks = 0